<template>
<div class="choosepage">
  <div>
    <div class="chooseCon" v-for="(item,index) in hostList" :key="index">
      <p class="condeteil" @click="homeFun(item)">
        <img src="../../assets/images/group.png" alt class="grouppic">
        <span>{{item.Name}}</span>
        <img src="../../assets/images/jt.png" alt class="jtpic">
      </p>
    </div>
  </div>
  <div class="botpic">
    <img src="../../assets/images/LOGO.png" alt>
  </div>
</div>
</template>

<script>
import {
  SetItem,
  GetHost,
  GetItem
} from "@/services/getData.js";
import weui from "weui.js";
export default {
  name: "choose-hospital",
  data() {
    return {
      hostList: [],
      source: -1 //-1默认值到挂号，0到建档
    };
  },
  created: function () {
    var _that = this;
    if (this.$route.query.source != undefined) {
      this.source = this.$route.query.source;
    }
    var loading = weui.loading("loading", {
      className: "custom-classname",
      content: "加载中"
    });
    GetHost().then(response => {
      loading.hide();
      _that.hostList = response.data;
      if (_that.hostList.length == 1) {
        //SetItem("backNumberTime", _that.hostList[0].BackNumberTime);
        //SetItem("hosid", _that.hostList[0].GUID);
        _that.homeFun(_that.hostList[0]);
      }
    });
  },
  methods: {
    homeFun(hosInfo) {
      SetItem("backNumberTime", hosInfo.BackNumberTime);
      SetItem("hosid", hosInfo.GUID);
      //跳转首页列表
      if (this.source == -1) {
        this.$router.push({
          path: "/register/registerhome"
        });
      }
      if (this.source == 0) {
        this.$router.push({
          path: "/card/addcard",
          query: {
            active: true,
            qrCode: this.$route.query.qrCode
          }
        });
      }
      if (this.source == 1) {
        //院区简介
        this.$router.push({
          path: "/hosname"
        });
      }
      if (this.source == 2) {
        //科室简介
        this.$router.push({
          path: "/sectionoffice"
        });
      }
      if (this.source == 3) {
        //预交金充值
        this.$router.push({
          path: "/IpPayment/IpPayment"
        });
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    if (from.name == 'home' || from.name == 'navigation') {
      next();
    } else {
      GetHost().then(response => {
        if (response.data.length == 1) {
          next('/');
        } else {
          next();
        }
      });

    }
  }
};
</script>

<style>
.choosepage {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/images/choosebg.png");
  background-size: 100% 100%;
}

.choosepage>div {
  height: calc(100% - 0.9rem);
}

.choosepage .chooseCon {
  width: 100%;
  height: 0.8rem;
  background: rgba(255, 255, 255, 1);
  font-size: 0.24rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 0.1rem;
  padding: 0 0.2rem;
  line-height: 0.8rem;
  box-sizing: border-box;
}

.choosepage .chooseCon .condeteil {
  position: relative;
}

.choosepage .grouppic {
  display: inline-block;
  width: 0.4rem;
  height: 0.4rem;
  background: rgba(21, 146, 228, 1);
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 0.1rem;
}

.choosepage .jtpic {
  display: inline-block;
  width: 0.14rem;
  height: 0.26rem;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -0.09rem;
}

.choosepage .botpic {
  width: 100%;
  height: 0.9rem;
}

.choosepage .botpic>img {
  width: 0.77rem;
  height: 0.64rem;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/home/choose-hospital.vue